import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getMemberGrow(params) {
	return client.get("member/dashboard/growing_per_week", {
		params: params,
	});
}

function getTenNewDownline(params) {
	return client.get("member/dashboard/ten_new_downline", {
		params: params,
	});
}

function getTotalDownline(params) {
	return client.get("member/dashboard/total_downline", {
		params: params,
	});
}

function getPotency(params) {
	return client.get("member/dashboard/potency", {
		params: params,
	});
}

function getCertificate(params) {
	return client.get("member/dashboard/certificate", {
		params: params,
	});
}

function getAnnouncements(params) {
	return client.get("/member/announcement/data", {
		params: params,
	});
}

function getTopSponsor3(params) {
	return client.get("/member/dashboard/top_sponsor", {
		params: params,
	});
}

export default {
	getMemberGrow,
  getTenNewDownline,
  getTotalDownline,
	getPotency,
	getCertificate,
	getAnnouncements,
	getTopSponsor3
};